import { Home } from 'lucide-react'
import { AddressBar } from '@/components/ui/address-bar'
import { PreviewPanelToggle } from '@/components/integrations/_shared/preview-panel-toggle'
import { testIds } from '@/lib/test-ids'
import { cn } from '@/lib/utils'

export type HomeChromeBarProps = {
  previewOpen: boolean
  onTogglePreview: () => void
  className?: string
}

/**
 * Surface-owned Home chrome: title row + PanelRight preview toggle.
 * Home is app-shell (outside workspace groups) - no workspace breadcrumb trail.
 * Sibling pattern to InboxThreadToolbar (not the document viewer toolbar).
 */
export function HomeChromeBar({
  previewOpen,
  onTogglePreview,
  className,
}: HomeChromeBarProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 min-w-0 border-b border-border/60 bg-background/80 px-1 pb-3 mb-4',
        className,
      )}
      data-testid={testIds.home.chromeBar}
    >
      <Home className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden />
      <div className="min-w-0 flex-1">
        <AddressBar
          segments={[{ label: 'Home', path: null }]}
          className="min-w-0"
        />
      </div>
      <PreviewPanelToggle
        open={previewOpen}
        onToggle={onTogglePreview}
        testId={testIds.home.previewToggle}
      />
    </div>
  )
}
